// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2MjIl","colCheckbox":"styles_colCheckbox__1oLmc"};